import React from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";

import { useCartStore } from "~/stores/use-cart-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import OrderCommentForm from "./order-comment-form";

export default function OrderCommentDialog() {
  const { t } = useTranslation("common");
  const { orderCommentDialogOpen, setOrderCommentDialogOpen } = useCartStore(
    useShallow((state) => ({
      orderCommentDialogOpen: state.orderCommentDialogOpen,
      setOrderCommentDialogOpen: state.setOrderCommentDialogOpen,
    })),
  );
  return (
    <Dialog
      open={orderCommentDialogOpen}
      onOpenChange={setOrderCommentDialogOpen}
    >
      <DialogContent onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader canClose={false}>
          <DialogTitle>{t("comment")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <OrderCommentForm onClose={() => setOrderCommentDialogOpen(false)} />
        </ScrollArea>
        <DialogFooter>
          <div className="flex flex-col gap-3 w-full">
            <Button
              size="lg"
              type="submit"
              form="order-comment-form"
              className="w-full text-xl"
              variant="success"
            >
              {t("Comment.apply")}
            </Button>
            <Button
              onClick={() => {
                setOrderCommentDialogOpen(false);
              }}
              className="w-full"
              variant="destructive"
            >
              {t("cancel")}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
